export default "__VITE_ASSET__HkE5gosP__"